export const KLARNA_LOCALE = {
  de: 'de-DE',
  gb: 'en-GB',
  fr: 'fr-FR',
  it: 'it-IT',
  es: 'es-ES',
};

export const KLARNA_UK_PAY_LATER_MAX_AMOUNT = 600;
export const KLARNA_GE_INSTALMENTS_MIN_AMOUNT = 45;
